<script setup>

</script>

<template>
  <!-- Footer -->
  <footer class="footer">
    <div class="footer__builder">
      <div class="container align-center">
        <div class="row">

          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
            <!-- titles -->
            <div class="h-titles">
              <div class="h-subtitle scroll-animate" data-animate="active">Address:</div>
              <div class="h-text scrolla-element-anim-1 scroll-animate" data-animate="active">
                Represented Talent,<br>
                Kemp House,<br>
                152-160 City Road,<br>
                London.<br>
                EC1V 2NX.<br>
                UK.</div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
            <!-- titles -->
            <div class="h-titles">
              <div class="h-subtitle scrolla-element-anim-1 scroll-animate" data-animate="active">Follow Us:</div>
            </div>
            <!-- social -->
            <div class="social-links footer-social-links">
              <a target="_blank" href="https://www.instagram.com/representedtalent/" class="scrolla-element-anim-1 scroll-animate" data-animate="active">
                <i aria-hidden="true" class="fab fa-instagram fa-2x"></i>
              </a>
              <a target="_blank" href="https://www.facebook.com/representedltd/" class="scrolla-element-anim-1 scroll-animate" data-animate="active">
                <i aria-hidden="true" class="fab fa-facebook-f fa-2x"></i>
              </a>
<!--              <a target="_blank" href="https://twitter.com/" class="scrolla-element-anim-1 scroll-animate" data-animate="active">-->
<!--                <i aria-hidden="true" class="fab fa-twitter"></i>-->
<!--              </a>-->
              <a target="_blank" href="https://www.linkedin.com/company/represented-talent/" class="scrolla-element-anim-1 scroll-animate" data-animate="active">
                <i aria-hidden="true" class="fab fa-linkedin-in fa-2x"></i>
              </a>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4">
            <!-- titles -->
            <div class="h-titles">
              <div class="h-subtitle scrolla-element-anim-1 scroll-animate" data-animate="active">Get in touch:</div>
              <div class="h-text scrolla-element-anim-1 scroll-animate" data-animate="active">
                <p>hello@representedtalent.com<br/>+44 (0)207 058 0010</p>
                <a href="/terms" class="text-white">Terms of Business</a>
              </div>
            </div>
          </div>

          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="copyright-text scrolla-element-anim-1 scroll-animate" data-animate="active">
              © {{ new Date().getFullYear() }} Represented Talent. All Rights Reserved</div>
          </div>

        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>

</style>